@use "../../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../../styles/layout";

.results {
    align-items: flex-start;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 16px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-direction: column;
    }
}

.viewAll {
    text-align: center;
}
